// Organization module page-level translations
export default {
  // ─── Common ──────────────────────────────────────────────────────────────
  'org.common.status.enable': 'Enable',
  'org.common.status.disable': 'Disable',
  'org.common.status.enabled': 'Enabled',
  'org.common.status.disabled': 'Disabled',
  'org.common.status.active': 'Active',
  'org.common.status.inactive': 'Inactive',
  'org.common.status.normal': 'Normal',
  'org.common.confirm': 'Confirm',
  'org.common.cancel': 'Cancel',
  'org.common.save': 'Save',
  'org.common.reset': 'Reset',
  'org.common.submit': 'Submit',
  'org.common.export': 'Export',
  'org.common.export.loading': 'Fetching export data, please wait…',
  'org.common.export.fetchFail': 'Failed to fetch export data',
  'org.common.export.noData': 'No data available to export',
  'org.common.export.success': 'Export successful',
  'org.common.export.fail': 'Export failed, please retry',
  'org.common.export.queryCondition': 'Query Conditions',
  'org.common.export.totalRecords': 'Total {count} records',
  'org.common.status.updating': 'Updating status…',
  'org.common.status.updateSuccess': 'Updated successfully',
  'org.common.status.updateFail': 'Update failed, please retry',
  'org.common.exportOptionExcel': 'Excel (.xlsx)',
  'org.common.exportOptionCsv': 'CSV (.csv)',
  'org.common.exportOptionPdf': 'PDF (.pdf)',
  'org.common.print': 'Print',
  'org.common.new': 'New',
  'org.common.edit': 'Edit',
  'org.common.backToList': 'Back to List',
  'org.common.field.status': 'Status',
  'org.common.field.remark': 'Remark',
  'org.common.field.creator': 'Creator',
  'org.common.field.createTime': 'Create Time',
  'org.common.field.updateTime': 'Update Time',
  'org.common.field.sort': 'Sort',
  'org.common.field.operation': 'Actions',
  'org.common.label.role': 'Role',
  'org.common.label.creator': 'Creator',
  'org.common.label.company': 'Company',
  'org.common.label.dept': 'Department',
  'org.common.sex.unknown': 'Unknown',
  'org.common.sex.male': 'Male',
  'org.common.sex.female': 'Female',

  // ─── Company ──────────────────────────────────────────────────────────────
  'org.company.title': 'Company Management',
  'org.company.new': 'New Company',
  'org.company.edit.title': 'Edit Company',
  'org.company.setting.title': 'Settings',
  'org.company.total': 'Total Companies',
  'org.company.filter.jointQuery': 'Joint Query',
  'org.company.filter.keyword.placeholder': 'Enter keyword (company / group tag)',
  'org.company.filter.tagLabel': 'Group Tag',
  'org.company.filter.name.placeholder': 'Enter company name',
  'org.company.filter.tag.placeholder': 'Enter group tag',
  'org.company.field.id': 'Company ID',
  'org.company.field.name': 'Company Name',
  'org.company.field.code': 'Company Code',
  'org.company.field.group': 'Group Tag',
  'org.company.field.sort': 'Sort',
  'org.company.field.userCount': 'User Count',
  'org.company.form.name.label': 'Company Name',
  'org.company.form.name.required': 'Please enter company name',
  'org.company.form.code.label': 'Company Code',
  'org.company.form.code.required': 'Please enter company code',
  'org.company.form.group.label': 'Group Tag',
  'org.company.form.sort.label': 'Sort',
  'org.company.form.sort.required': 'Please enter sort value',
  'org.company.form.status.placeholder': 'Please select status',
  'org.company.form.remark.label': 'Remark',
  'org.company.form.remark.placeholder': 'Please enter remark',
  'org.company.error.notFound': 'Company not found',
  'org.company.error.fetchFail': 'Failed to fetch company info',
  'org.company.setting.usedToken': 'Current Token Usage',
  'org.company.setting.daily': 'Daily',
  'org.company.setting.weekly': 'Weekly',
  'org.company.setting.monthly': 'Monthly',
  'org.company.setting.resetConfirm': 'Confirm reset usage to 0?',
  'org.company.setting.companyQuota': 'Company Quota',
  'org.company.setting.userDefaultQuota': 'User Default Quota',
  'org.company.setting.dailyQuota': 'Daily Quota (tokens)',
  'org.company.setting.weeklyQuota': 'Weekly Quota (tokens)',
  'org.company.setting.monthlyQuota': 'Monthly Quota (tokens)',
  'org.company.setting.zeroUnlimited': '0 means unlimited',
  'org.company.setting.saveSuccess': 'Settings saved successfully',
  'org.company.setting.saveFail': 'Failed to save settings',
  'org.company.setting.resetSuccess': 'Usage reset successfully',
  'org.company.setting.resetFail': 'Reset failed, please retry',
  'org.company.setting.fetchFail': 'Failed to fetch settings',

  // ─── Department ──────────────────────────────────────────────────────────────
  'org.dept.title': 'Department Management',
  'org.dept.new': 'New Department',
  'org.dept.edit.title': 'Edit Department',
  'org.dept.total': 'Total Departments',
  'org.dept.field.id': 'Department ID',
  'org.dept.field.name': 'Department Name',
  'org.dept.field.company': 'Company',
  'org.dept.field.deptCount': 'Member Count',
  'org.dept.form.name.label': 'Department Name',
  'org.dept.form.name.required': 'Please enter department name',
  'org.dept.form.name.placeholder': 'Please enter department name',
  'org.dept.form.company.label': 'Company',
  'org.dept.form.company.required': 'Please select company',
  'org.dept.form.company.placeholder': 'Select company',
  'org.dept.form.sort.label': 'Sort',
  'org.dept.form.sort.placeholder': 'Please enter sort value',
  'org.dept.form.remark.label': 'Remark',
  'org.dept.form.remark.placeholder': 'Please enter remark',
  'org.dept.error.notFound': 'Department not found',
  'org.dept.error.fetchFail': 'Failed to fetch department info',
  'org.dept.filter.keyword.placeholder': 'Enter keyword',
  'org.dept.filter.name.placeholder': 'Enter department name',
  'org.dept.filter.company.placeholder': 'Select company',

  // ─── Role ──────────────────────────────────────────────────────────────
  'org.role.title': 'Role Management',
  'org.role.new': 'New Role',
  'org.role.add.title': 'Add Role',
  'org.role.edit.title': 'Edit Role',
  'org.role.edit.breadcrumb': 'Edit Role',
  'org.role.total': 'Total Roles',
  'org.role.field.id': 'Role ID',
  'org.role.field.name': 'Role Name',
  'org.role.field.ownerCompany': 'Owner Company',
  'org.role.field.description': 'Description (Optional)',
  'org.role.field.basicInfo': 'Basic Info',
  'org.role.form.name.label': 'Role Name',
  'org.role.form.name.required': 'Please enter role name',
  'org.role.form.name.placeholder': 'Please enter role name',
  'org.role.form.description.label': 'Description (Optional)',
  'org.role.form.description.placeholder': 'Please enter description',
  'org.role.perm.functionTree': 'Function Tree',
  'org.role.perm.permCode': 'Permission Code',
  'org.role.perm.view': 'View',
  'org.role.perm.edit': 'Edit',
  'org.role.perm.delete': 'Delete',
  'org.role.perm.add': 'Add',
  'org.role.perm.export': 'Export',
  'org.role.perm.print': 'Print',
  'org.role.perm.searchPlaceholder': 'Search by menu name or permission code',
  'org.role.action.batchEnable': 'Batch Enable',
  'org.role.action.batchDisable': 'Batch Disable',
  'org.role.action.batchOperation': 'Batch Actions',
  'org.role.action.copyRole': 'Copy Role',
  'org.role.action.select': 'Select',
  'org.role.action.queryRelated': 'Query Related',
  'org.role.error.noRoleId': 'Invalid parameters: missing role ID',
  'org.role.error.fetchFail': 'Failed to fetch role details',
  'org.role.error.updateFail': 'Update failed',
  'org.role.error.saveFail': 'Save failed',
  'org.role.form.company.required': 'Please select owner company',
  'org.role.form.company.placeholder': 'Select company',
  'org.role.form.remark.placeholder': 'Up to 3 lines',
  'org.role.filter.keyword.placeholder': 'Enter keyword (role/creator/company)',
  'org.role.filter.createBy.placeholder': 'Select creator',
  'org.role.filter.company.placeholder': 'Select company',

  // ─── User ──────────────────────────────────────────────────────────────
  'org.user.title': 'User Management',
  'org.user.new': 'New User',
  'org.user.copy': 'Copy User',
  'org.user.edit.title': 'Edit User',
  'org.user.edit.subtitle': 'Fields marked with * are required',
  'org.user.section.basic': 'Basic Info',
  'org.user.section.org': 'Organization & Permissions',
  'org.user.section.contact': 'Contact Info',
  'org.user.form.weightHint': 'Weight must be less than {max}',
  'org.user.detail.title': 'User Detail',
  'org.user.total': 'Total Users',
  'org.user.view.card': 'Card',
  'org.user.view.list': 'List',
  'org.user.field.id': 'User ID',
  'org.user.field.account': 'Account',
  'org.user.field.nickname': 'Nickname',
  'org.user.field.email': 'Email',
  'org.user.field.company': 'Company',
  'org.user.field.dept': 'Department',
  'org.user.field.deptShort': 'Dept',
  'org.user.field.phone': 'Phone',
  'org.user.field.phone1': 'Alt Phone',
  'org.user.col.phone1': 'Phone 1',
  'org.user.col.phone2': 'Phone 2',
  'org.common.search.placeholder': 'Search',
  'org.user.field.weight': 'Account Weight',
  'org.user.field.sex': 'Gender',
  'org.user.form.account.required': 'Please enter account name',
  'org.user.form.account.maxLen': 'Account name must not exceed 50 characters',
  'org.user.form.account.pattern': 'Account name only supports letters, numbers, and .-_ symbols',
  'org.user.form.account.placeholder': 'Please enter account name',
  'org.user.form.nickname.required': 'Please enter nickname',
  'org.user.form.nickname.placeholder': 'Please enter nickname',
  'org.user.form.email.required': 'Please enter email',
  'org.user.form.email.invalid': 'Please enter a valid email address',
  'org.user.form.email.placeholder': 'Please enter email',
  'org.user.form.sex.required': 'Please select gender',
  'org.user.form.status.required': 'Please select status',
  'org.user.form.company.placeholder': 'Search by company name',
  'org.user.form.company.required': 'Please select company',
  'org.user.form.dept.placeholder': 'Select department',
  'org.user.form.phone.placeholder': 'Please enter phone number',
  'org.user.form.phone1.placeholder': 'Please enter alternate phone number',
  'org.user.form.weight.required': 'Please enter account weight',
  'org.user.form.weight.placeholder': 'Please enter account weight',
  'org.user.form.weight.label': 'Account Weight (must be less than {max})',
  'org.user.filter.keyword.placeholder': 'Enter keyword (account/nickname/email/company/dept)',
  'org.user.filter.company.placeholder': 'Enter company',
  'org.user.filter.phone1.placeholder': 'Enter phone 1',
  'org.user.filter.phone2.placeholder': 'Enter phone 2',
  'org.user.filter.nickname.placeholder': 'Select or enter nickname',
  'org.user.filter.account.placeholder': 'Select or enter account',
  'org.user.filter.email.placeholder': 'Select or enter email',
  'org.user.filter.companySelect.placeholder': 'Select or enter company',
  'org.user.filter.dept.placeholder': 'Select or enter department',
  'org.user.add.success': 'Added successfully',
  'org.user.add.fail': 'Failed to add',
  'org.user.add.copyFetchFail': 'Failed to fetch user info for copying',
  'org.user.add.systemError': 'System error, please try again later',
  'org.user.add.modalTitle': 'User Added Successfully',
  'org.user.add.modalDesc': 'Below are the details of the newly created user. Please save the initial password securely.',
  'org.user.add.copyAccountPwd': 'Copy Account & Password',
  'org.user.add.close': 'Close',
  'org.user.add.copyText': 'Account: {account}\nPassword: {password}',
  'org.user.add.copySuccess': 'Account and password copied to clipboard',
  'org.user.add.copyFail': 'Copy failed, please copy manually',
  'org.user.add.desc.account': 'User Account',
  'org.user.add.desc.initPwd': 'Initial Password',
  'org.user.add.desc.phone': 'Phone Number',
  'org.user.add.desc.createTime': 'Create Time',
  'org.user.add.subtitle': 'Fields marked with * are required. An initial password will be generated upon submission.',
  'org.user.edit.success': 'Updated successfully',
  'org.user.edit.fail': 'Update failed',
  'org.user.edit.fetchFail': 'Failed to fetch user info',
  'org.user.edit.noId': 'User ID not found',
  'org.user.edit.systemError': 'System error, please try again later',
  'org.user.action.editProfile': 'Edit Profile',
  'org.user.action.permManage': 'Permissions',
  'org.user.action.quota': 'Quota',
  'org.user.action.copy': 'Copy',
  'org.user.action.enable': 'Enable',
  'org.user.action.disable': 'Disable',
  'org.user.action.batchImport': 'Batch Import',
  'org.user.detail.noData': 'No data',
  'org.user.detail.back': 'Back',
  'org.user.detail.roleInfo': 'Role Info',
  'org.user.detail.roleField': 'Role',

  // Batch Import
  'org.user.batchImport.title': 'Batch Import Users',
  'org.user.batchImport.downloadTemplate': 'Download Template',
  'org.user.batchImport.uploadCard': 'Upload Import File',
  'org.user.batchImport.guide.title': 'Import Instructions',
  'org.user.batchImport.guide.basicRequire': 'Basic Requirements',
  'org.user.batchImport.guide.req1': 'Download the template first. Do not modify the first row headers. Fill in data from the second row.',
  'org.user.batchImport.guide.req2': 'Supports .xlsx and .xls formats. Import starts automatically after file selection.',
  'org.user.batchImport.guide.req3': 'After successful import, the system automatically generates initial passwords, displayed on the result page. Please screenshot and inform users.',
  'org.user.batchImport.guide.fieldDesc': 'Field Description (10 columns)',
  'org.user.batchImport.guide.colName': 'Column',
  'org.user.batchImport.guide.colRequired': 'Required',
  'org.user.batchImport.guide.colRule': 'Rules',
  'org.user.batchImport.guide.required': 'Required',
  'org.user.batchImport.guide.optional': 'Optional',
  'org.user.batchImport.guide.row.account.rule': 'Unique, must not duplicate existing accounts',
  'org.user.batchImport.guide.row.nickname.rule': 'Display name, duplicates allowed',
  'org.user.batchImport.guide.row.status.rule': '1 = Enabled (default), 0 = Disabled',
  'org.user.batchImport.guide.row.company.rule': 'Must exactly match an existing company name in the system',
  'org.user.batchImport.guide.row.dept.rule': 'Must exactly match an existing department name; leave blank for no department',
  'org.user.batchImport.guide.row.weight.rule': 'Positive integer; higher value means higher operation privileges; default if blank',
  'org.user.batchImport.guide.row.email.rule': 'Valid email format for notifications',
  'org.user.batchImport.guide.row.phone.rule': '11-digit number',
  'org.user.batchImport.guide.row.sex.rule': 'M = Male, F = Female; blank means unknown',
  'org.user.batchImport.upload.dragging': 'Click or drag file to this area to upload',
  'org.user.batchImport.upload.hint': 'Import starts automatically after file selection. Supports .xlsx and .xls formats.',
  'org.user.batchImport.upload.spinning': 'Uploading and importing, please wait...',
  'org.user.batchImport.result.success': 'Import successful, {count} records imported',
  'org.user.batchImport.result.partial': 'Import complete: {count} succeeded, some records failed',
  'org.user.batchImport.result.continue': 'Import More',
  'org.user.batchImport.result.backToList': 'Back to User List',
  'org.user.batchImport.result.failDetail': 'Failure Details',
  'org.user.batchImport.result.countUnit': 'records',
  'org.user.batchImport.result.successList': 'Successfully Imported Users',
  'org.user.batchImport.result.pwdWarning': 'Please record initial passwords and notify users promptly. Passwords cannot be viewed after leaving this page.',
  'org.user.batchImport.result.pwdNotice': 'Initial passwords are shown only once. Please screenshot or copy before leaving.',
  'org.user.batchImport.error.importFail': 'Import failed, please retry',
  'org.user.batchImport.error.uploadFail': 'Upload failed, please check network and retry',
  'org.user.batchImport.col.account': 'Account',
  'org.user.batchImport.col.nickname': 'Nickname',
  'org.user.batchImport.col.email': 'Email',
  'org.user.batchImport.col.initPwd': 'Initial Password',

  // Quota Modal
  'org.user.quota.title': 'Quota Management',
  'org.user.quota.usedToken': 'Current Token Usage',
  'org.user.quota.daily': 'Daily',
  'org.user.quota.weekly': 'Weekly',
  'org.user.quota.monthly': 'Monthly',
  'org.user.quota.resetConfirm': 'Confirm reset usage to 0?',
  'org.user.quota.reset': 'Reset',
  'org.user.quota.dailyLimit': 'Daily Limit (tokens)',
  'org.user.quota.weeklyLimit': 'Weekly Limit (tokens)',
  'org.user.quota.monthlyLimit': 'Monthly Limit (tokens)',
  'org.user.quota.zeroUnlimited': '0 means unlimited',
  'org.user.quota.saveSuccess': 'Quota saved successfully',
  'org.user.quota.saveFail': 'Save failed, please retry',
  'org.user.quota.fetchFail': 'Failed to fetch quota info',
  'org.user.quota.fetchFail2': 'Failed to fetch quota info, please retry',
  'org.user.quota.resetSuccess': 'Usage reset successfully',
  'org.user.quota.resetFail': 'Reset failed, please retry',

  // Role List Modal
  'org.user.roleModal.title': 'Select Role',
  'org.user.roleModal.ok': 'Confirm Selection',
  'org.user.roleModal.headerTitle': 'Role List',
  'org.user.roleModal.selected': '{count} item(s) selected',
  'org.user.roleModal.col.name': 'Role Name',
  'org.user.roleModal.col.status': 'Status',
  'org.user.roleModal.col.remark': 'Remark',
  'org.user.roleModal.col.creator': 'Creator',
  'org.user.roleModal.col.createTime': 'Create Time',
  'org.user.roleModal.status.normal': 'Normal',
  'org.user.roleModal.status.disabled': 'Disabled',
  'org.user.roleModal.name.placeholder': 'Please enter role name',
  'org.user.roleModal.search.placeholder': 'Enter keyword (role/creator/company)',

  // Permission Modal
  'org.user.permModal.title': 'Configure Private Permissions',
  'org.user.permModal.searchPlaceholder': 'Search by menu name or permission code',
  'org.user.permModal.added': 'Privately Added',
  'org.user.permModal.removed': 'Privately Removed',
  'org.user.permModal.error.noId': 'Invalid parameters: missing user ID or role ID',
  'org.user.permModal.error.fetchFail': 'Failed to fetch permission data',
  'org.user.permModal.saveSuccess': 'Saved successfully',
  'org.user.permModal.saveFail': 'Save failed',

  // User Detail Drawer
  'org.user.drawer.title': 'User Detail',
  'org.user.drawer.tab.basic': 'Basic Info',
  'org.user.drawer.tab.roles': 'Roles',
  'org.user.drawer.col.roleName': 'Role Name',
  'org.user.drawer.col.status': 'Status',
  'org.user.drawer.col.remark': 'Remark',
  'org.user.drawer.status.active': 'Active',
  'org.user.drawer.status.inactive': 'Inactive',
  'org.user.drawer.status.enabled': 'Enabled',
  'org.user.drawer.status.disabled': 'Disabled',
  'org.user.drawer.noRoles': 'No roles',
  'org.user.drawer.field.account': 'Account',
  'org.user.drawer.field.nickname': 'Nickname',
  'org.user.drawer.field.email': 'Email',
  'org.user.drawer.field.phone': 'Phone',
  'org.user.drawer.field.sex': 'Gender',
  'org.user.drawer.field.company': 'Company',
  'org.user.drawer.field.dept': 'Department',
  'org.user.drawer.field.weight': 'Account Weight',
  'org.user.drawer.field.createTime': 'Create Time',
  'org.user.drawer.field.updateTime': 'Update Time',

  // User List Modal
  'org.user.userModal.title': 'Reference Permissions',
  'org.user.userModal.ok': 'Confirm Selection',
  'org.user.userModal.headerTitle': 'User List',
  'org.user.userModal.selected': '{count} item(s) selected',
  'org.user.userModal.col.account': 'Account',
  'org.user.userModal.col.nickname': 'Nickname',
  'org.user.userModal.col.email': 'Email',
  'org.user.userModal.col.status': 'Status',
  'org.user.userModal.col.company': 'Company',
  'org.user.userModal.col.dept': 'Department',
  'org.user.userModal.col.creator': 'Creator',
  'org.user.userModal.col.weight': 'Account Weight',
  'org.user.userModal.status.enabled': 'Enabled',
  'org.user.userModal.status.disabled': 'Disabled',
  'org.user.userModal.nickname.placeholder': 'Please enter nickname',
  'org.user.userModal.search.placeholder': 'Enter keyword (account/nickname/email/company/department)',

  // User Card
  'org.user.card.status.active': 'Active',
  'org.user.card.status.inactive': 'Inactive',
  'org.user.card.action.lock': 'Lock',
  'org.user.card.action.enable': 'Enable',
  'org.user.card.action.perm': 'Permissions',
  'org.user.card.action.edit': 'Edit',
  'org.user.card.noPermission': 'Insufficient Permission',
  'org.user.card.nickname': 'Nickname',
  'org.user.card.companyName': 'Company Name',

  // User Permission Page
  'org.user.perm.pageTitle': 'User Permission Management',
  'org.user.perm.isManager': 'Admin',
  'org.user.perm.createdAt': 'Created:',
  'org.user.perm.statusActive': 'Active',
  'org.user.perm.statusInactive': 'Inactive',
  'org.user.perm.account': 'Account',
  'org.user.perm.company': 'Company',
  'org.user.perm.phone': 'Phone',
  'org.user.perm.sex': 'Gender',
  'org.user.perm.col.roleName': 'Role Name',
  'org.user.perm.col.roleId': 'Role ID',
  'org.user.perm.col.status': 'Status',
  'org.user.perm.col.remark': 'Remark',
  'org.user.perm.col.grantor': 'Granted By',
  'org.user.perm.col.grantTime': 'Grant Time',
  'org.user.perm.col.ownerCompany': 'Owner Company',
  'org.user.perm.col.operation': 'Actions',
  'org.user.perm.status.normal': 'Normal',
  'org.user.perm.status.disabled': 'Disabled',
  'org.user.perm.action.remove': 'Remove',
  'org.user.perm.action.customize': 'Customize',
  'org.user.perm.action.restore': 'Restore',
  'org.user.perm.btn.add': 'Add',
  'org.user.perm.btn.reference': 'Reference Permissions',
  'org.user.perm.btn.remove': 'Remove',
  'org.user.perm.btn.cancelSelect': 'Cancel Selection',
  'org.user.perm.selected': '{count} item(s) selected',
  'org.user.perm.setManager': 'Set as Admin',
  'org.user.perm.cancelManager': 'Remove Admin',
  'org.user.perm.resetPwd': 'Reset Password',
  'org.user.perm.confirm.setManager': 'Confirm Set as Admin',
  'org.user.perm.confirm.cancelManager': 'Confirm Remove Admin',
  'org.user.perm.confirm.setManagerContent': 'Are you sure to set user {name} as system administrator?',
  'org.user.perm.confirm.cancelManagerContent': 'Are you sure to remove admin privileges from user {name}?',
  'org.user.perm.confirm.setManagerSuccess': 'Set as system administrator',
  'org.user.perm.confirm.cancelManagerSuccess': 'Admin privileges removed',
  'org.user.perm.confirm.resetPwd': 'Confirm Reset Password',
  'org.user.perm.confirm.resetPwdContent': 'Are you sure to reset the password for user {account}?',
  'org.user.perm.resetPwd.success': 'Password Reset Successfully',
  'org.user.perm.resetPwd.account': 'Account:',
  'org.user.perm.resetPwd.newPwd': 'New Password:',
  'org.user.perm.resetPwd.tip': 'Please keep the new password safe. It is recommended to change it after first login.',
  'org.user.perm.resetPwd.ok': 'Got it',
  'org.user.perm.resetPwd.failPrefix': 'Password reset failed: ',
  'org.user.perm.resetPwd.fail': 'Password reset failed',
  'org.user.perm.remove.confirm': 'Confirm Removal',
  'org.user.perm.remove.content': 'Are you sure to remove the selected {count} role(s)? This action cannot be undone.',
  'org.user.perm.remove.loading': 'Removing...',
  'org.user.perm.remove.success': 'Removed successfully',
  'org.user.perm.remove.fail': 'Removal failed',
  'org.user.perm.restore.confirm': 'Confirm Restore',
  'org.user.perm.restore.content': 'Are you sure to clear private permissions for this role? Default role permissions will be used after restore.',
  'org.user.perm.restore.loading': 'Restoring...',
  'org.user.perm.restore.success': 'Restored successfully',
  'org.user.perm.restore.fail': 'Restore failed',
  'org.user.perm.reference.loading': 'Referencing permissions from {count} user(s)...',
  'org.user.perm.reference.success': 'Successfully referenced permissions from {count} user(s)',
  'org.user.perm.reference.fail': 'Failed to reference permissions, please try again',
  'org.user.perm.reference.noSelect': 'Please select users to reference',
  'org.user.perm.role.loading': 'Assigning {count} role(s) to user...',
  'org.user.perm.role.success': 'Successfully assigned {count} role(s) to user',
  'org.user.perm.role.fail': 'Role assignment failed, please try again',
  'org.user.perm.role.noSelect': 'Please select at least one role',
  'org.user.perm.error.noUserId': 'User ID not found',
  'org.user.perm.error.fetchFail': 'Failed to fetch user info',
  'org.user.perm.error.opFail': 'Operation failed',
  'org.user.perm.error.opFail2': 'Operation failed, please try again',
  'org.user.perm.perm.saveSuccess': 'Permission configuration updated',
};
